<template>
  <div class="form-bootstrapWizard col-xs-12 col-md-12 rowSpacing">
    <ul class="bootstrapWizard form-wizard rowSpacing">
      <!--<li :class="['uno', {'active': verHabitaciones || verHabitacion}]">
        <span class="step">1</span> <span class="title">{{texto.Pasos.uno}}</span>
      </li>
      <li :class="['dos', {'active': verificada}]">
        <span class="step">2</span> <span class="title">{{texto.Pasos.dos}}</span>
      </li>
      <li :class="['tres', {'active': personales}]">
        <span class="step">3</span> <span class="title">{{texto.Pasos.tres}}</span>
      </li>
      <li :class="['cuatro', {'active': verResumen}]">
        <span class="step">4</span> <span class="title">{{texto.Pasos.cuatro}}</span>
      </li>-->
      <li :class="[ 'uno', {'active' : (step==1)}]">
        <span class="step">1</span> <span class="title">{{idioma.uno}}</span>
      </li>
      <li :class="['dos',  { 'active' : (step==2)  }]">
        <span class="step">2</span> <span class="title">{{idioma.dos}}</span>
      </li>
      <li :class="[ 'tres', {'active' : (step==3)}]">
        <span class="step">3</span> <span class="title">{{idioma.tres}}</span>
      </li>
      <li :class="[ 'cuatro', {'active' : (step==4)}]">
        <span class="step">4</span> <span class="title">{{idioma.cuatro}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "booking-steps",
    props: ["idioma","step"],
    data() {
      return {

      }
    },

    methods: {

    }
  }
</script>




// WEBPACK FOOTER //
// src/components/shared/BookingSteps.vue